import funcion from './funcion/funcion'

const comun = {
  funcion: funcion
}

export default comun;



//////////////////
// WEBPACK FOOTER
// ./static/js/api/comun/comunapi.js
// module id = null
// module chunks = 